// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sendReceipt/stylesheets/styles.sass
 ** module id = 389
 ** module chunks = 1
 **/